var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficialFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 0H3.75C2.75544 0 1.80161 0.395088 1.09835 1.09835C0.395088 1.80161 0 2.75544 0 3.75L0 31.25C0 32.2446 0.395088 33.1984 1.09835 33.9016C1.80161 34.6049 2.75544 35 3.75 35H14.4727V23.1008H9.55078V17.5H14.4727V13.2312C14.4727 8.37578 17.3633 5.69375 21.7906 5.69375C23.9109 5.69375 26.1281 6.07188 26.1281 6.07188V10.8375H23.6852C21.2781 10.8375 20.5273 12.3312 20.5273 13.8633V17.5H25.9008L25.0414 23.1008H20.5273V35H31.25C32.2446 35 33.1984 34.6049 33.9016 33.9016C34.6049 33.1984 35 32.2446 35 31.25V3.75C35 2.75544 34.6049 1.80161 33.9016 1.09835C33.1984 0.395088 32.2446 0 31.25 0Z",
    fill: "#AAAAAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialFacebook);
export default __webpack_public_path__ + "static/media/officialFacebook.45032a59.svg";
export { ForwardRef as ReactComponent };